var map = {
	"./AuthorPhoto.jpg": 3660,
	"./Forest.jpg": 2592,
	"./HappinessFallsCover.jpg": 4782,
	"./MiracleCreek.JPEG": 4986,
	"./NPR.png": 9980,
	"./PBS.jpg": 1673,
	"./ScrawlBooks.png": 255,
	"./TheGuardian.jpg": 5176,
	"./Variety.jpg": 7435,
	"./Waves.jpg": 7419,
	"./WavesOriginal.jpg": 5263,
	"./WavesOriginal.png": 8152,
	"./account_multiple_icon_135993.png": 7136,
	"./amazon.png": 3782,
	"./angiekim.png": 360,
	"./apple.png": 9667,
	"./audiobooks.png": 1223,
	"./barnesandnoble.jpg": 1666,
	"./barnesandnoble.png": 1439,
	"./bookData": 8045,
	"./bookData.js": 8045,
	"./booksamillion.png": 4231,
	"./bookshop.png": 2854,
	"./coverBackground.png": 634,
	"./coverImageForest.png": 2992,
	"./coverImageWaves.png": 4860,
	"./coverText.png": 7847,
	"./download.png": 7201,
	"./events": 3671,
	"./events.js": 3671,
	"./googleBooks.png": 8753,
	"./hudsonBooksellers.png": 8141,
	"./indieBound.png": 5124,
	"./politicsAndProse.png": 4923,
	"./prh.png": 523,
	"./retailers": 9868,
	"./retailers.js": 9868,
	"./target.jpg": 153,
	"./target.png": 5431,
	"./walmart.png": 7743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;